import styled from "styled-components";
import * as React from "react";
import { CircularHover } from "./CircularHover";
import { IconButton } from "./IconButton";

interface Props {
  onClick: () => void;
  disabled?: boolean;
  title?: string;
}

const Body = styled.div``;

const Icon = styled(IconButton)`
  color: ${props => (props.disabled ? "#ccc" : "#04a4de")};
  opacity: 1;
`;

/** Custom Notebook Execute play button. */
export const ExecuteIconButton = React.memo((props: Props) => (
  <Body
    className="cell-execution-button"
    style={{
      position: "relative",
      alignItems: "center",
      justifyContent: "center",
      height: "24px",
      width: "24px",
      boxSizing: "border-box",
      cursor: "pointer",
    }}
  >
    <Icon
      icon="play_arrow"
      onClick={props.onClick}
      disabled={props.disabled}
      title={props.title}
      style={{
        position: "absolute",
        boxSizing: "border-box",
        width: 20,
        height: 20,
      }}
      size="medium"
    />
    {!props.disabled && <CircularHover />}
  </Body>
));
